import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Experience = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* Job Experience Section */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2024 - Present</p>
          <h2 className="text-3xl md:text-4xl font-bold">Work Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-auto border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Full Stack AI Engineer Intern"
            subTitle="IntalksAI · Remote"
            result="Aug 2025 - Present"
            des="Built FastAPI services with JWT auth, Pydantic validation, and RBAC. Tested REST endpoints using Postman; caught authentication gaps before production. Managed Docker containerization and AWS EC2 deployments with health-check endpoints."
          />
          <ResumeCard
            title="GDG Lead - Google Developer Groups"
            subTitle="IILM University"
            result="Aug 2024 - Sep 2025"
            des="Organized 6+ technical sessions on Linux, REST APIs, secure coding, and OWASP Top 10 for 50+ students. Coordinated 2 hackathons, mentored 8 teams on backend development and API security best practices."
          />
          <ResumeCard
            title="PHP / WordPress Developer"
            subTitle="DigitalDose · Mumbai"
            result="Jun - Aug 2024"
            des="Audited WordPress forms for SQL injection vulnerabilities; rewrote 4 raw query blocks using prepared statements. Optimized database queries, reducing page load time by ~25% and removing insecure direct file inclusion patterns."
          />
        </div>
      </div>
      
      {/* Certifications & Training */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">Certifications</p>
          <h2 className="text-3xl md:text-4xl font-bold">Achievements</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-auto border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Google Cybersecurity Professional Certificate"
            subTitle="Certification"
            result="2024 - 2025"
            des="Completed comprehensive cybersecurity training covering OWASP Top 10, threat models, secure network design, and defensive strategies."
          />
          <ResumeCard
            title="Ethical Hacking - Infosys Springboard"
            subTitle="Certification"
            result="2024"
            des="Hands-on training with penetration testing tools: Nmap, Burp Suite, Wireshark; practiced exploiting SQLi, XSS, IDOR, and broken authentication vulnerabilities."
          />
          <ResumeCard
            title="Hackathon Achievements"
            subTitle="Recognition"
            result="2024 - 2025"
            des="2nd Place - NIET Hackathon. 1st Prize - Web Design Competition (IILM University). Project Management Intern - Reliance Digital & Microsoft Copilot (Sep 2025)."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Experience;
